// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireConditionIsEqualToFragmentDoc = gql`
    fragment questionnaireConditionIsEqualTo on QuestionnaireConditionIsEqualTo {
  __typename
  question {
    id
  }
  valueString: value
}
    `;